/* eslint-disable  react/jsx-no-constructed-context-values */

import React, { SyntheticEvent, useCallback, useState } from 'react';
import { Shop } from '../../../types/Feature';

interface ScheduledFeatureContextProps {
    shops: Shop[];
    setShops: (shops: Shop[]) => void;
    handleShopUpdate: (index: number, updatedShop: Shop) => void;
    handleFieldUpdate: (index: number, field: string, value: any) => void;
    enableAllShops: () => void;
    disableAllShops: () => void;
    handleAddShop: (event: SyntheticEvent) => void;
    deleteShop: (index: number) => void;
}
export const ScheduledFeatureContext = React.createContext<ScheduledFeatureContextProps>({
    shops: [] as Shop[],
    setShops: (shops: any[]) => {},
    handleShopUpdate: (index: number, updatedShop: Shop) => {},
    handleFieldUpdate: (index: number, field: string, value: any) => {},
    enableAllShops: () => {},
    disableAllShops: () => {},
    handleAddShop: (event: SyntheticEvent) => {},
    deleteShop: (index: number) => {},
});

export const useScheduledFeatureContext = () => React.useContext(ScheduledFeatureContext);

export const ScheduledFeatureProvider = ({ children }: any) => {
    const [shops, setShops] = useState<Shop[]>([]);

    const handleShopUpdate = useCallback((index: number, updatedShop: Shop) => {
        setShops((prevShop) => {
            const updatedShops = [...prevShop];
            updatedShops[index] = updatedShop;
            return updatedShops;
        });
    }, []);

    const enableAllShops = useCallback(() => {
        const allShopsEnabled = shops.map((shop: Shop) => ({ ...shop, enabled: true }));
        setShops(allShopsEnabled);
    }, [shops]);

    const disableAllShops = useCallback(() => {
        const allShopsEnabled = shops.map((shop: Shop) => ({ ...shop, enabled: false }));
        setShops(allShopsEnabled);
    }, [shops]);

    const handleAddShop = useCallback((event: SyntheticEvent) => {
        event.preventDefault();
        setShops((prevShops: Shop[]) => [...prevShops, { address: '', assignment_code: '', enabled: false }]);
    }, []);

    const handleFieldUpdate = (index: number, field: string, value: string | number) => {
        const updatedShops: any = [...shops];
        updatedShops[index][field] = value;
        setShops(updatedShops);
    };

    const deleteShop = useCallback(
        (index: number) => {
            const updatedShops = shops.filter((shop, i) => i !== index);
            setShops(updatedShops);
        },
        [shops],
    );

    return (
        <ScheduledFeatureContext.Provider
            value={{
                shops,
                setShops,
                handleShopUpdate,
                enableAllShops,
                disableAllShops,
                handleFieldUpdate,
                handleAddShop,
                deleteShop,
            }}
        >
            {children}
        </ScheduledFeatureContext.Provider>
    );
};
